<template>
  <div id="beforeAfterOne"></div>
</template>

<script>
export default {
  name: "BeforeAfterOne",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        beforeLabel: "Before",
        beforeValue: "12 hours",
        afterLabel: "After",
        afterValue: "30 minutes",
        context: "Time to complete monthly reports",
        chip: "Results",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    isDarkColor(color) {
      let r, g, b;
      if (color.startsWith("#")) {
        const hex = color.slice(1);
        if (hex.length === 3) {
          r = parseInt(hex[0] + hex[0], 16);
          g = parseInt(hex[1] + hex[1], 16);
          b = parseInt(hex[2] + hex[2], 16);
        } else {
          r = parseInt(hex.substring(0, 2), 16);
          g = parseInt(hex.substring(2, 4), 16);
          b = parseInt(hex.substring(4, 6), 16);
        }
      } else {
        const rgb = color.match(/\d+/g);
        if (!rgb || rgb.length < 3) return false;
        r = parseInt(rgb[0]);
        g = parseInt(rgb[1]);
        b = parseInt(rgb[2]);
      }
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness < 128;
    },
    render() {
      const el = document.getElementById("beforeAfterOne");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const valueSize = exporting ? 80 : 80 * this.scale;
      const labelSize = exporting ? 28 : 28 * this.scale;
      const contextSize = exporting ? 32 : 32 * this.scale;
      const logoHeight = exporting ? 50 : 50 * this.scale;
      const chipSize = exporting ? 24 : 24 * this.scale;
      const arrowSize = exporting ? 60 : 60 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#000000";

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background-color: #f5f5f5;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
          "
        >
          <div style="padding: 10%">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" />
          </div>

          <div style="padding: 0 10%;">
            <div style="border-left: 6px solid #272727; padding-left: 25px; margin-bottom: 40px;">
              <div style="
                font-size: ${contextSize}px;
                font-weight: 500;
                color: #272727;
                line-height: 1.3;
              ">${this.data.context}</div>
            </div>

            <div style="display: flex; align-items: center; gap: 40px; padding-left: 31px;">
              <!-- Before -->
              <div style="flex: 1;">
                <div style="
                  font-size: ${labelSize}px;
                  font-weight: 500;
                  color: #737373;
                  margin-bottom: 8px;
                  text-transform: uppercase;
                  letter-spacing: 0.1em;
                ">${this.data.beforeLabel}</div>
                <div style="
                  font-size: ${valueSize}px;
                  font-weight: 700;
                  color: #272727;
                  line-height: 1;
                  text-decoration: line-through;
                  text-decoration-color: #ef4444;
                  opacity: 0.6;
                ">${this.data.beforeValue}</div>
              </div>

              <!-- Arrow -->
              <div style="font-size: ${arrowSize}px; color: ${primaryColor};">→</div>

              <!-- After -->
              <div style="flex: 1;">
                <div style="
                  font-size: ${labelSize}px;
                  font-weight: 500;
                  color: ${primaryColor};
                  margin-bottom: 8px;
                  text-transform: uppercase;
                  letter-spacing: 0.1em;
                ">${this.data.afterLabel}</div>
                <div style="
                  font-size: ${valueSize}px;
                  font-weight: 700;
                  color: ${primaryColor};
                  line-height: 1;
                ">${this.data.afterValue}</div>
              </div>
            </div>
          </div>

          <div style="padding: 10%">
            <div style="display: flex;">
              <span
                style="
                  display: inline-block;
                  background: ${primaryColor};
                  color: ${this.isDarkColor(primaryColor) ? "#fff" : "#000"};
                  font-size: ${chipSize}px;
                  font-weight: 500;
                  border-radius: 999px;
                  padding: 7px 22px;
                  letter-spacing: 0.03em;
                  font-family: 'Inter', Arial, sans-serif;
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style scoped></style>
